<template>
  <Dialog ref="p">
    <div class="dialog-content">
      <div class="title">链接组队</div>
      <div class="sub-title">他人点击此链接即可成为你的队员</div>
        <div class="select"></div>
        <div class="link" @click="copyLink()">{{share_url}}</div>
      <div class="desc">点击此链接可拷贝</div>
    </div>
  </Dialog>
</template>
<style lang='scss' scoped>
  .dialog-content {
    width: 295px;
    height: 200px;
    padding: 30px 42px;
    text-align: center;

    .title {
      font-size: 18px;
      color: #3A3A3A;
      margin-bottom: 10px;

      @include semibold();
    }

    .sub-title {
      font-size: 13px;
      color: #3A3A3A;
      // margin-bottom: 30px;

      @include regular();
    }

    .link {
      margin-top: 30px;
      background: #F5F5F5;
      border: 1px solid #AAAAAA;
      font-size: 13px;
      color: #3A3A3A;
      height: 34px;
      line-height: 34px;
      margin-bottom: 5px;
      white-space: nowrap;
      overflow: hidden;

      @include regular();
    }

    .desc {
      font-size: 13px;
      color: #B5B5B5;

      @include regular();
    }
  }

</style>
<script>
  // import Clipboard from 'clipboard'
  // import { getVersion } from '@/utils'
  import { mapState } from 'vuex'
  import { $toast } from '@/views/common/Loading.js'
  import { setPasteBoard } from '@/assistant/JSBridge'
  import Dialog from 'components/Dialog'
  export default {
    components: {
      Dialog
    },
    computed: {
      ...mapState({
        share_url: state => state.user.share_url
      })
    },
    mounted () {
      $bus.$on('showLink', () => {
        this.show()
      })
    },
    destroyed () {
      $bus.$off('showLink')
    },
    methods: {
      copyLink () {
        setPasteBoard(this.share_url)
          .then((res) => {
            if (res['status'] === 'ok') {
              $toast.show('复制成功', 2000)
            } else {
              $toast.show(res['error'], 2000)
            }
          })
      },
      show () {
        this.$refs.p.show()
      },
      hide () {
        this.$refs.p.hide()
      }
    }
  }
</script>
